
import { Card, Col, Row, Typography, theme, Spin, ConfigProvider, Flex, Button, Layout } from "antd"
import { Link } from "react-router-dom"
import { useGetSharedLinks } from "../../api/moneyflow/moneyflow"
import MoneyFlowLogo from '../../assets/MoneyFlow_logo.svg?react'
import { useState } from "react"
import { MoonOutlined, SunOutlined } from "@ant-design/icons"

const { Title } = Typography

export const SharedLinksPage = () => {
    const [darkMode, setDarkMode] = useState(false)
    const { data: sharedLinks, isLoading } = useGetSharedLinks()
    const { token } = theme.useToken()

    const toggleDarkMode = () => {
        setDarkMode((prev) => !prev)
    }

    if (isLoading) {
        return <Spin style={{ display: "block", margin: "auto" }} />
    }

    return (
        <ConfigProvider theme={{
            algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm
        }}>
            <Layout style={{ height: '100vh', width: '100%', padding: token.paddingLG }}>
                <Flex justify="space-between" align="center" >
                    <a style={{ display: 'inline-block', width: '300px' }} href="https://lite.bitquery.io/" title="MoneyFlow Lite"><MoneyFlowLogo width={189} height={60} /></a>
                    <Button title={darkMode ? 'Enable Light Mode' : 'Enable Dark Mode'} icon={darkMode ? <MoonOutlined /> : <SunOutlined />} onClick={toggleDarkMode} />
                </Flex>
                <Title level={2}>Explore Trending MoneyFlows</Title>
                <Typography.Paragraph>
                    Discover what others are exploring right now. Dive into the most popular shared addresses and stay updated with the latest trends in blockchain activity.
                </Typography.Paragraph>
                <Row style={{ width: '100%', overflow: 'scroll' }} gutter={[token.marginXS, token.marginXS]}>
                    {sharedLinks?.map((link) => (
                        <Col key={link.originalId} >
                            <Card
                                title={link.name}
                                extra={<Link to={`/share/${link.originalId}/${link.name}`}>View</Link>}
                                style={{ borderRadius: token.borderRadius, width: "500px" }}
                            >
                                <a href={`/share/${link.originalId}/${link.name}`}>
                                    <img
                                        alt={link.name}
                                        src={`/public/get-preview/${link.originalId}`}
                                        style={{
                                            height: 200,
                                            width: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                </a>
                                <p><strong>Address:</strong> {link.address}</p>
                                <p><strong>Blockchain:</strong> {link.network}</p>
                                {link.createdAt && <p>
                                    <strong>Created:</strong> {new Date(link.createdAt).toLocaleDateString()}
                                </p>}
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Layout>
        </ConfigProvider>
    )
}
